// Vendors
import React from 'react';

// Components
import { ProjectCard } from '../AdminDashboard/components/AllProjects/components';

const AllApprovedProjects = ({
  projects,
  selectedProjectIDs,
  handleSelectProject
}) =>
  projects.length >= 1 &&
  projects.map((project) => (
    <ProjectCard
      key={project.pid}
      project={project}
      selectable={true}
      selected={selectedProjectIDs.includes(project.pid)}
      onClickHandler={handleSelectProject}
    />
  ));

export default AllApprovedProjects;
